<div class="page-header">
  <div class="header-row">
    <div></div><!-- spacer -->
    <div class="page-actions-right" *ngIf="showMyTicketsHeader">
      <button class="btn-create-ticket" (click)="openCreateTicketModal()">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
        </svg>
        Create Ticket
      </button>
    </div>
  </div>
</div>
<div class="ticket-container">

  <!-- PAGE HEADER -->

  <!-- FILTERS SECTION -->
  <div class="filters-section">
    <div class="filters-row">
      <!-- Category Filter Chips -->
      <ng-container *ngIf="isReceivingSide">
        <div class="filter-chip" [class.active]="currentCategory === 'company'" (click)="switchCategory('company')">
          Company Tickets
          <span class="count">{{ ticketCounts['recieving_admin']?.count || 0}}</span>
        </div>
        <div class="filter-chip" [class.active]="currentCategory === 'po'" (click)="switchCategory('po')">
          PO Tickets
          <span class="count">{{ ticketCounts['product_owner']?.count || 0 }}</span>
        </div>
      </ng-container>

      <ng-container *ngIf="!isReceivingSide">
        <div class="filter-chip" [class.active]="currentCategory === 'company'" (click)="switchCategory('company')">
          Company Tickets
          <span class="count">{{ ticketCounts['organization_admin']?.count || 0}}</span>
        </div>
        <div class="filter-chip" [class.active]="currentCategory === 'driver'" (click)="switchCategory('driver')">
          Driver Tickets
          <span class="count">{{ticketCounts['driver']?.count || 0 }}</span>
        </div>
        <div class="filter-chip" [class.active]="currentCategory === 'customer'" (click)="switchCategory('customer')">
          Customer Tickets
          <span class="count">{{ticketCounts['customer']?.count || 0}}</span>
        </div>
        <div class="filter-chip" [class.active]="currentCategory === 'my'" (click)="switchCategory('my')">
          My Tickets
          <span class="count">{{ ticketCounts['my']?.count || 0 }}</span>
        </div>
      </ng-container>

      <div class="filter-divider"></div>

      <!-- Status Radio Filters -->
      <div *ngIf="counts" class="radio-filter-group">
        <label class="radio-filter-item">
          <input type="radio" name="statusFilter" value="all" [checked]="currentStatus === 'all'"
            (change)="switchStatus('all')">
          <span class="radio-filter-label">All <span class="radio-filter-count">({{ counts[0]?.count }})</span></span>
        </label>
        <label class="radio-filter-item">
          <input type="radio" name="statusFilter" value="closed" [checked]="currentStatus === 'close'"
            (change)="switchStatus('close')">
          <span class="radio-filter-label">Closed <span class="radio-filter-count">({{ counts[2]?.count
              }})</span></span>
        </label>
        <label class="radio-filter-item">
          <input type="radio" name="statusFilter" value="open" [checked]="currentStatus === 'open'"
            (change)="switchStatus('open')">
          <span class="radio-filter-label">Open <span class="radio-filter-count">({{ counts[1]?.count }})</span></span>
        </label>
      </div>

      <!-- Right Side Actions -->
      <div class="filter-actions">
        <div class="search-box">
          <svg xmlns="http://www.w3.org/2000/svg" class="search-icon" fill="none" viewBox="0 0 24 24" stroke-width="2"
            stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z" />
          </svg>
          <input type="text" class="search-input" placeholder="Search tickets..." [(ngModel)]="searchQuery"
            (input)="onSearch(searchQuery)">

          <svg *ngIf="cross" (click)="clearText()" class="cross-icon" width="16" height="16"
            xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </div>
      </div>
    </div>
  </div>

  <!-- TABLE SECTION -->
  <div class="table-section">



    <div class="table-wrapper">
      <table class="ticket-table">
        <thead>
          <tr>
            <th>Ticket ID</th>
            <!-- <th>Customer Name</th> -->
            <th *ngIf="currentCategory == 'company'">Company Name</th>
            <th *ngIf="currentCategory == 'customer'">Customer Name</th>
            <th *ngIf="currentCategory == 'driver'">Driver Name</th>
            <th *ngIf="currentCategory == 'my'">Admin Name</th>
            <th>Subject</th>
            <th>Report Time</th>
            <th>Last Update</th>
            <th>Status</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <!-- Skeleton Rows -->
          <ng-container *ngIf="isLoading">
            <tr class="skeleton-row" *ngFor="let i of [1,2,3,4,5,6,7,8,9,10]">
              <td>
                <div class="skeleton-id">
                  <div class="skeleton-icon"></div>
                  <div class="skeleton-block skeleton-sno-text"></div>
                </div>
              </td>
              <td>
                <div class="skeleton-block skeleton-text"></div>
              </td>
              <td>
                <div class="skeleton-block skeleton-text"></div>
              </td>
              <td>
                <div class="skeleton-block skeleton-text"></div>
              </td>
              <td>
                <div class="skeleton-block skeleton-text"></div>
              </td>
              <td>
                <div class="skeleton-block skeleton-badge"></div>
              </td>
              <td>
                <div class="skeleton-actions">
                  <div class="skeleton-btn"></div>
                  <div class="skeleton-btn"></div>
                  <div class="skeleton-btn"></div>
                </div>
              </td>
            </tr>
          </ng-container>

          <!-- Actual Data Rows -->
          <ng-container *ngIf="!isLoading">
            <tr *ngFor="let ticket of filteredTickets" [attr.data-status]="ticket.status">
              <td>
                <div class="ticket-id">
                  <svg class="ticket-icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                    stroke-width="2" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round"
                      d="M16.5 6v.75m0 3v.75m0 3v.75m0 3V18m-9-5.25h5.25M7.5 15h3M3.375 5.25c-.621 0-1.125.504-1.125 1.125v3.026a2.999 2.999 0 010 5.198v3.026c0 .621.504 1.125 1.125 1.125h17.25c.621 0 1.125-.504 1.125-1.125v-3.026a2.999 2.999 0 010-5.198V6.375c0-.621-.504-1.125-1.125-1.125H3.375z" />
                  </svg>
                  {{ ticket.id }}
                </div>
              </td>
              <td *ngIf="currentCategory == 'customer' || currentCategory == 'driver' || currentCategory == 'my'">
                <div class="customer-name">{{ ticket.created_by }}</div>
              </td>
              <td *ngIf="currentCategory == 'company' && isReceivingSide">
                <div class="customer-name">{{ticket.extra_data?.receiver_company }}</div>
              </td>
              <td *ngIf="currentCategory == 'company' && !isReceivingSide">
                <div class="customer-name">{{ ticket.extra_data?.sender_company }}</div>
              </td>
              <td>
                <div class="subject-text">{{ ticket.subject }}</div>
              </td>
              <td>
                <div class="report-time"> {{ convertUtcToLocalDate(ticket.created_at) }},
                  {{ formatETDA(ticket.created_at) }}</div>
              </td>
              <td>
                <div class="last-update">{{ formatETDA(ticket.updated_at) }}</div>
              </td>
              <td (click)="goToTicketDetail(ticket)">
                <span class="status-badge"
                  [ngClass]="ticket.ticket_status?.toLowerCase() === 'close' ? 'closed' : 'open'">

                  {{ ticket.ticket_status === 'close' ? 'Closed' : (ticket.ticket_status | titlecase) }}
                </span>
              </td>
              <td>
                <div class="action-buttons">
                  <div class="contact-trigger-wrapper">
                    <button class="action-btn call" (click)="callCustomer(ticket, $event)" title="Call"
                      [class.active]="activeContactId === ticket.id">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                        stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round"
                          d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 002.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 01-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 00-1.091-.852H4.5A2.25 2.25 0 002.25 4.5v2.25z" />
                      </svg>
                    </button>

                    <!-- Contact Popover -->
                    <div class="contact-popover" *ngIf="activeContactId === ticket.id" (click)="$event.stopPropagation()">
                      <div class="popover-arrow"></div>
                      <div class="popover-header">
                        <span class="popover-name">{{ ticket.created_by }}</span>
                        <span class="popover-phone">{{ getTicketPhone(ticket) }}</span>
                      </div>
                      <div class="popover-actions">
                        <button class="popover-btn call" (click)="initiateCall(getTicketPhone(ticket), $event)"
                          title="Call Now">
                          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 002.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 01-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 00-1.091-.852H4.5A2.25 2.25 0 002.25 4.5v2.25z" />
                          </svg>
                        </button>
                        <button class="popover-btn whatsapp" (click)="openWhatsApp(getTicketPhone(ticket), $event)"
                          title="WhatsApp Chat">
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                            <path d="M13.601 2.326A7.854 7.854 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.06 3.973L0 16l4.14-1.086c1.162.634 2.478.969 3.811.969h.005a7.862 7.862 0 0 0 5.86-2.569 7.854 7.854 0 0 0 2.23-5.611c.002-2.112-.822-4.095-2.316-5.592h-.001zm-5.607 11.458h-.003a6.55 6.55 0 0 1-3.342-.915l-.24-.143-2.484.652.662-2.42-.156-.248a6.539 6.539 0 0 1-1.003-3.484c.002-3.605 2.942-6.545 6.548-6.545a6.548 6.548 0 0 1 4.632 1.92 6.548 6.548 0 0 1 1.916 4.636c-.002 3.605-2.942 6.545-6.548 6.545zm3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.089-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.729.729 0 0 0-.529.247c-.182.198-.691.677-.691 1.654 0 .977.71 1.916.81 2.049.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232z" />
                          </svg>
                        </button>
                        <button class="popover-btn copy" (click)="copyToClipboard(getTicketPhone(ticket), $event, ticket.id)"
                          title="Copy Number">
                          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M15.666 3.888A2.25 2.25 0 0 0 13.5 2.25h-3c-1.03 0-1.9.693-2.166 1.638m7.332 0c.055.194.084.4.084.612v0a.75.75 0 0 1-.75.75H9a.75.75 0 0 1-.75-.75v0c0-.212.03-.418.084-.612m7.332 0c.646.049 1.288.11 1.927.184 1.1.128 1.907 1.077 1.907 2.185V19.5a2.25 2.25 0 0 1-2.25 2.25H6.75A2.25 2.25 0 0 1 4.5 19.5V6.257c0-1.108.806-2.057 1.907-2.185a48.208 48.208 0 0 1 1.927-.184" />
                          </svg>
                        </button>
                      </div>
                      <div class="copied-badge" *ngIf="showCopiedId === ticket.id">
                        Copied!
                      </div>
                    </div>
                  </div>
                  <button class="action-btn message" (click)="goToTicketDetail(ticket)" title="Message">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                      stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round"
                        d="M8.625 12a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H8.25m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H12m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0h-.375M21 12c0 4.556-4.03 8.25-9 8.25a9.764 9.764 0 01-2.555-.337A5.972 5.972 0 015.41 20.97a5.969 5.969 0 01-.474-.065 4.48 4.48 0 00.978-2.025c.09-.457-.133-.901-.467-1.226C3.93 16.178 3 14.189 3 12c0-4.556 4.03-8.25 9-8.25s9 3.694 9 8.25z" />
                    </svg>
                    <span *ngIf="oneIsTrue(ticket.messages)" class="unread"></span>
                  </button>
                  <button class="action-btn delete" (click)="deleteTicket(ticket.id,ticket.schema_name)" title="Delete">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                      stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round"
                        d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0" />
                    </svg>
                  </button>
                </div>
              </td>
            </tr>

            <!-- Empty State -->
            <tr *ngIf="filteredTickets.length === 0">
              <td colspan="7">
                <div class="empty-state">
                  <div class="empty-icon-wrapper">
                    <div class="floating-element element-1">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                          d="M16.5 6v.75m0 3v.75m0 3v.75m0 3V18m-9-5.25h5.25M7.5 15h3M3.375 5.25c-.621 0-1.125.504-1.125 1.125v3.026a2.999 2.999 0 010 5.198v3.026c0 .621.504 1.125 1.125 1.125h17.25c.621 0 1.125-.504 1.125-1.125v-3.026a2.999 2.999 0 010-5.198V6.375c0-.621-.504-1.125-1.125-1.125H3.375z" />
                      </svg>
                    </div>
                    <div class="floating-element element-2">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                          d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z" />
                      </svg>
                    </div>
                    <div class="floating-element element-3">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                          d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
                      </svg>
                    </div>
                    <svg class="main-empty-icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                      stroke-width="1.5" stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round"
                        d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z" />
                    </svg>
                  </div>
                  <h3 class="empty-title">No tickets found</h3>
                  <p class="empty-subtitle">We couldn't find any tickets matching your current filters.</p>
                </div>
              </td>
          </ng-container>
        </tbody>
      </table>
    </div>
  </div>

  <!-- PAGINATION FOOTER -->
  <div class="pagination-footer">
    <!-- <div class="pagination-info">{{ getPaginationInfo() }}</div> -->
    <button class="pagination-btn" (click)="previousPage()" [disabled]="isPreviousDisabled()" title="Previous Page">
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
      </svg>
    </button>
    <div class="pagination-info">
      <!-- Page {{ currentPage }} of {{ totalPages }} -->
      {{ getPaginationInfo() }}
    </div>
    <button class="pagination-btn" (click)="nextPage()" [disabled]="isNextDisabled()" title="Next Page">
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
      </svg>
    </button>
  </div>

</div>